import assetPath from '/app/packages/entity-pages/entity-pages-employees/src/assets/card-blur.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')